import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignRolesDialogComponent } from './assign-roles-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormModule, MaterialModule, SharedModule } from 'components';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [
    AssignRolesDialogComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    FormModule,
    MatDialogModule,
    SharedModule,
    MaterialModule
  ]
})
export class AssignRolesDialogModule { }
